import { PATHS } from '../../../constants/routes';

export interface TextPosition {
    horizontal: 'left' | 'center' | 'right';
    vertical: 'top' | 'center' | 'bottom' | 'mob-bottom';
}

export interface Slide {
    image: string;
    imageMobile?: string;
    pretitle?: string;
    title: string;
    subtitle?: string;
    discount?: { value: string; unit: '%' | '₽'; text: string };
    linkText?: string;
    linkPath: string;
    textPosition: TextPosition;
    class?: string;
    type: 'promo' | 'regular';
    goalId?: string;
    visibleUntil?: string | null;
}

export const SLIDES: Slide[] = [
    // {
    //     image: '/home-page/christmas/slide_02.png',
    //     imageMobile: '/home-page/christmas/slide_02-m.png',
    //     title: 'Собери \nновогодний комплект ',
    //     subtitle: 'при заказе от 3-х товаров. \nВ акции  не участвуют резинки для волос. ',
    //     discount: { value: '-25', unit: '%', text: 'до 15 января' },
    //     linkText: 'Собрать комплект',
    //     linkPath: `${PATHS.showcase}?fullPrice=1&campaign=promo`,
    //     textPosition: { horizontal: 'center', vertical: 'center' },
    //     class: 'christmasSlide',
    //     type: 'promo',
    //     goalId: 'click_button_soberi_ng_compect',
    //     visibleUntil: '15.01.2026',
    // },
    // {
    //     image: '/home-page/christmas/slide_01-big.png',
    //     imageMobile: '/home-page/christmas/slide_01-m.png',
    //     title: 'Золотая сказка \nдля дома',
    //     subtitle: 'Новогодняя скидка на любое одеяло из эксклюзивной коллекции «Золотой шелк». ',
    //     discount: { value: '-30', unit: '%', text: 'до 15 января' },
    //     linkText: 'Успеть купить',
    //     linkPath: `${PATHS.showcase}?typesOfFiller=gold`,
    //     textPosition: { horizontal: 'left', vertical: 'center' },
    //     class: 'christmasSlideTwo',
    //     type: 'promo',
    //     goalId: 'click_button_zolotaya_skazka',
    //     visibleUntil: '15.01.2026',
    // },
    // {
    //     image: '/home-page/january/slide_01.png',
    //     imageMobile: '/home-page/january/slide_01-m.png',
    //     title: 'Золотая сказка \nдля дома',
    //     subtitle: 'Скидка на любое одеяло из эксклюзивной коллекции «Золотой шелк».',
    //     discount: { value: '-30', unit: '%', text: 'до 31 января' },
    //     linkText: 'Успеть купить',
    //     linkPath: `${PATHS.showcase}?typesOfFiller=gold`,
    //     textPosition: { horizontal: 'left', vertical: 'center' },
    //     class: 'christmasSlideTwo',
    //     type: 'promo',
    //     goalId: 'click_button_zolotaya_skazka',
    //     visibleUntil: '31.01.2026',
    // },
    // {
    //     image: '/home-page/january/slide_02.png',
    //     imageMobile: '/home-page/january/slide_02-m.png',
    //     title: 'Собери \nсвой комплект',
    //     subtitle: 'при заказе от 3-х товаров. \nВ акции  не участвуют резинки для волос.',
    //     discount: { value: '-25', unit: '%', text: 'до 31 января' },
    //     linkText: 'Собрать комплект',
    //     linkPath: `${PATHS.showcase}?fullPrice=1&campaign=promo`,
    //     textPosition: { horizontal: 'center', vertical: 'center' },
    //     class: 'christmasSlide',
    //     type: 'promo',
    //     goalId: 'click_button_soberi_ng_compect',
    //     visibleUntil: '31.01.2026',
    // },
    // {
    //     image: '/home-page/valentines/slide_01.png',
    //     imageMobile: '/home-page/valentines/slide_01-m.png',
    //     title: 'Комплимент \nдля двоих',
    //     subtitle: 'На вторую подушку при покупке 2-х штук.',
    //     discount: { value: '-50', unit: '%', text: 'до 15 февраля' },
    //     linkText: 'Купить',
    //     linkPath: `${PATHS.showcase}/pillows`,
    //     textPosition: { horizontal: 'center', vertical: 'center' },
    //     class: 'valentineSlide',
    //     type: 'promo',
    //     goalId: 'click_button_kompliment_dlya_dvoih',
    //     visibleUntil: '15.02.2026',
    // },
    // {
    //     image: '/home-page/spring/slide_03.png',
    //     imageMobile: '/home-page/spring/slide_03-m.png',
    //     title: 'Сон \nв весеннюю ночь',
    //     subtitle: 'На все комплекты постельного белья.',
    //     discount: { value: '-15', unit: '%', text: 'до 15 марта' },
    //     linkText: 'Купить',
    //     linkPath: `${PATHS.showcase}/bed-linen`,
    //     textPosition: { horizontal: 'center', vertical: 'center' },
    //     class: 'springSlide',
    //     type: 'promo',
    //     visibleUntil: '15.03.2026',
    // },
    // {
    //     image: '/home-page/spring/slide_02.png',
    //     imageMobile: '/home-page/spring/slide_02-m.png',
    //     title: 'Твой нежный сон',
    //     subtitle: 'На все наборы для сна.',
    //     discount: { value: '-25', unit: '%', text: 'до 15 марта' },
    //     linkText: 'Купить',
    //     linkPath: `${PATHS.showcase}/accessories`,
    //     textPosition: { horizontal: 'center', vertical: 'center' },
    //     class: 'springSlide',
    //     type: 'promo',
    //     visibleUntil: '15.03.2026',
    // },
    // {
    //     image: '/home-page/spring/slide_01.png',
    //     imageMobile: '/home-page/spring/slide_01-m.png',
    //     title: 'Весенний \nкомплимент',
    //     subtitle: 'На вторую подушку при покупке 2-х штук.',
    //     discount: { value: '-50', unit: '%', text: 'до 15 марта' },
    //     linkText: 'Купить',
    //     linkPath: `${PATHS.showcase}/pillows`,
    //     textPosition: { horizontal: 'center', vertical: 'center' },
    //     class: 'springSlide',
    //     type: 'promo',
    //     goalId: 'click_button_spring_compliment',
    //     visibleUntil: '15.03.2026',
    // },
    // {
    //     image: '/home-page/update/01.png',
    //     imageMobile: '/home-page/update/01-m.png',
    //     title: 'Время обновления',
    //     subtitle: 'Шелковистый сатин в трендовых оттенках \nдля вашей идеальной спальни.',
    //     discount: { value: '-15', unit: '%', text: 'этим летом' },
    //     linkText: 'Выбрать',
    //     linkPath: `${PATHS.showcase}/bed-linen`,
    //     textPosition: { horizontal: 'left', vertical: 'center' },
    //     class: 'updateBanner',
    //     type: 'promo',
    //     // goalId: 'update_time',
    // },
    {
        image: '/home-page/autumn/01.jpg',
        imageMobile: '/home-page/autumn/01-m.jpg',
        title: 'Территория \nроскошного сна',
        subtitle: 'На одеяла с наполнителем из шелка.',
        discount: { value: '-30', unit: '%', text: '' },
        linkText: 'Купить',
        linkPath: `${PATHS.showcase}/blankets`,
        textPosition: { horizontal: 'left', vertical: 'center' },
        class: 'updateBannerBlack',
        type: 'promo',
        // goalId: 'territory_luxury_sleep',
    },
    {
        image: '/home-page/autumn/02.jpg',
        imageMobile: '/home-page/autumn/02-m.jpg',
        title: 'Бьюти-дуэт',
        subtitle: 'Шёлковые наборы для сна со скидкой -25%.',
        discount: { value: '3 562', unit: '₽', text: '4 749₽' },
        linkText: 'Выбрать цвет',
        linkPath: `${PATHS.showcase}/accessories`,
        textPosition: { horizontal: 'left', vertical: 'center' },
        class: 'updateBannerPrice',
        type: 'promo',
        // goalId: 'spring_beauty_duo',
    },
    {
        image: '/home-page/autumn/03.jpg',
        imageMobile: '/home-page/autumn/03-m.jpg',
        title: 'Одеяло, \nс которым легко',
        subtitle: 'Лёгкое шёлковое одеяло. \nПодходит для машинной стирки.',
        discount: { value: '30 519', unit: '₽', text: '43 598₽' },
        linkText: 'Купить',
        linkPath: `/odeyalo-letnee-zelenyy-chay-shelk-tussa-razmer-200kh230`,
        textPosition: { horizontal: 'left', vertical: 'center' },
        class: 'updateBannerPrice',
        type: 'promo',
        // goalId: 'blanket_easy_use',
    },
    {
        image: '/home-page/first_slide.jpg',
        imageMobile: '/home-page/first_slide-m2.jpg',
        pretitle: 'Премиум-текстиль для здорового сна',
        title: 'Шелковые подушки \nи одеяла S-Gabai',
        // linkText: 'Подробнее',
        // linkPath: PATHS.luxuryArt,
        linkPath: PATHS.showcase,
        textPosition: { horizontal: 'center', vertical: 'mob-bottom' },
        class: 'mobFirstSlide',
        type: 'regular',
        visibleUntil: null,
    },
    {
        image: '/home-page/luxury-art.jpg',
        imageMobile: '/home-page/luxury-art-m.jpg',
        pretitle: 'Коллекция Золотой шелк',
        title: 'Эксклюзив \nот С.Габай',
        // linkText: 'Подробнее',
        // linkPath: PATHS.luxuryArt,
        linkPath: '#luxury-art',
        textPosition: { horizontal: 'center', vertical: 'bottom' },
        type: 'regular',
        visibleUntil: null,
    },
    {
        image: '/home-page/sleep-territory.jpg',
        imageMobile: '/home-page/sleep-territory-m.jpg',
        pretitle: 'Территория сна',
        title: 'Одеяла и подушки \nиз шелка',
        // linkText: 'Подробнее',
        // linkPath: PATHS.sleepTerritory,
        linkPath: '#sleep-territory',
        textPosition: { horizontal: 'left', vertical: 'bottom' },
        type: 'regular',
        visibleUntil: null,
    },
    {
        image: '/home-page/best-silk.jpg',
        imageMobile: '/home-page/best-silk-m.jpg',
        pretitle: 'Основа здорового сна',
        title: 'О лучшем в мире шелке',
        // linkText: 'Подробнее',
        // linkPath: PATHS.bestSilk,
        linkPath: '#best-silk',
        textPosition: { horizontal: 'right', vertical: 'center' },
        type: 'regular',
        visibleUntil: null,
    },
];
